import React, { useState } from "react";
import { package_options } from "../../../../../constants";
import eventEmitter from "../../eventEmitter";

function PackageSelect(props) {
    const { name, label, onChange, value, options, id, required } = props;
    const [error, setError] = useState("Please select a package.");

    const handleChange = (e) => {
        onChange(e);
        eventEmitter.emit("onPackageChange", {
            value: e.target.value,
            id: id,
        });
        if(required && e.target.value !== ''){
            setError("");
        }
        if(required && e.target.value === ''){
            setError("Please select a package");
        }
    };

    return (
        <div class="input-wrapper">
            <label htmlFor={name}>{label}</label>
            <select name={name} id={name} onChange={handleChange}>
                <option value={""} selected={value == ""}>
                    None
                </option>
                {options.split(",").map((key) => (
                    <option value={key} selected={value == key}>
                        {package_options[key]}
                    </option>
                ))}
            </select>
            {required && error && <p style={{ color: "red", fontSize: "0.9em" }}>{error}</p>}
        </div>
    );
}

export default PackageSelect;
